module.exports = __webpack_public_path__ + "img/banner_vip-person.0386ec76.png";